// src/components/Header.jsx

import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const menu = [
    {
      text: "Sobre",
      link: "#about",
    },
    {
      text: "Soluções",
      link: "#services",
    },
    {
      text: "Diagnóstico Gratuito",
      link: "#approach",
    },
    {
      text: "Resultados",
      link: "#benefits",
    },
  ];
  return (
    <header
      className={`header ${isScrolled ? "scrolled" : ""} ${
        isMenuOpen ? "menu-open" : ""
      }`}
    >
      <nav className="navbar">
        <div className="logo">
          <a href="/">DB VISION</a>
        </div>

        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <ul>
            {menu.map((item, index) => (
              <li>
                <a href={item.link}>{item.text}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="header-actions">{/* BOTÃO ATUALIZADO */}</div>

        <a href="#contacts" className="services-button">
          Fale Conosco
        </a>

        <div className="hamburger" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
